import { operatorClient } from 'domain/HttpClients';

/**
 *
 * @param filters
 * @param headers
 * @returns {*}
 */
export const fetchPending = (filters) => operatorClient
  .Get('/api/reconciliation/pending')
  .withParams(filters)
  .send();
/**
 *
 * @param payload
 * @param headers
 * @returns {*}
 */
export const downloadPending = (payload) => operatorClient
  .Get('/api/reconciliation/pending/download')
  .withParams(payload)
  .send();

/**
 *
 * @param payload
 * @param headers
 * @returns {*}
 */
export const generate = (payload) => operatorClient
  .Post('/api/reconciliation/generate')
  .withData(payload)
  .send();
